import { Section } from "../ui/Section";
import { Eyebrow } from "../ui/Eyebrow";
import { H2, Highlight } from "../ui/Heading";
import { MOMENTS } from "../data/moments";
import { MomentRow } from "./MomentRow";

export function ADay() {
  return (
    <Section id="a-day">
      <Eyebrow n="02">A day with Sidestack</Eyebrow>
      <H2 className="max-w-[920px]">
        Every moment that <Highlight>used to suck</Highlight>, handled.
      </H2>
      <p className="mt-4.5 max-w-[640px] text-lg leading-relaxed text-td-2">
        You know these moments. The unread pile at 7am. The lead who pings
        while you're on a call. The deal that just went quiet and you didn't
        notice. Here's how each one plays out with Sidestack on.
      </p>
      <div className="mt-16 flex flex-col gap-7">
        {MOMENTS.map((m, i) => (
          <MomentRow key={m.time} moment={m} reverse={i % 2 === 1} />
        ))}
      </div>
    </Section>
  );
}
